function SubscriptionSource () {
	this.headerMegaNav = document.querySelector( '#header-mega-nav' );
	this.headerMegaNavDialog = this.headerMegaNav?.closest( '#user-modal' );
	this.megaNavManageSubscriptionText = document.getElementById(
		'header-meganav-manage-your-subscription-text',
	);
	this.accountLink = document.getElementById( 'header-meganav-account-link' );
	this.megaNavDescription = document.getElementById(
		'header-meganav-description',
	);
	this.absMmaPanel = document.querySelector( '[data-js-abs-mma-panel]' );
	this.pianoImagePanel = document.querySelector( '[data-js-piano-image]' );
	this.activateSubscriptionElement = document.getElementById(
		'header-meganav-activate-your-subscription',
	);
}

SubscriptionSource.prototype.init = function () {
	if ( this.headerMegaNav ) {
		this.headerMegaNav.setAttribute( 'aria-busy', 'true' );
		this.fallbackTimeout = window.setTimeout(
			this.showFallback.bind( this ),
			5000,
		);
	}
};

SubscriptionSource.prototype.setSubscriptionOrigin = function ( subscriptionOrigin ) {
	window.subscriptionOrigin = subscriptionOrigin;

	if (
		subscriptionOrigin &&
		( subscriptionOrigin === 'piano' || subscriptionOrigin === 'both' )
	) {
		this.absMmaPanel?.remove();
		this.activateSubscriptionElement?.remove();
		this.headerMegaNavDialog?.classList.add( 'user-modal--piano' );
	} else {
		this.removeNonPianoElements();
	}
	this.show();
};

SubscriptionSource.prototype.removeNonPianoElements = function () {
	this.pianoImagePanel?.remove();
	if ( this.headerMegaNav ) {
		this.headerMegaNav.classList.add( 'HeaderMegaNav--AlignItemsTop' );
	}
	this.megaNavDescription?.remove();
	if ( this.megaNavManageSubscriptionText ) {
		this.megaNavManageSubscriptionText.textContent = 'Account settings';
	}
	this.showAccountSettingsLink();
};

SubscriptionSource.prototype.showFallback = function () {
	this.removeNonPianoElements();
	this.show();
};

SubscriptionSource.prototype.showAccountSettingsLink = function () {
	if ( this.accountLink?.dataset.accountSettingsUrl ) {
		this.accountLink.href = this.accountLink.dataset.accountSettingsUrl;
	}
};

SubscriptionSource.prototype.show = function () {
	if ( this.headerMegaNav ) {
		window.clearTimeout( this.fallbackTimeout );
		this.headerMegaNav.classList.remove( 'HeaderMegaNav--Loading' );
		this.headerMegaNav.removeAttribute( 'aria-busy' );
	}
};

export default SubscriptionSource;
